import { useEffect } from 'react';
import { Outlet } from 'react-router';
import { SidebarMenu } from 'layout';
import { useOfflineNetworkToast } from 'hooks/common';
import { useIntercomChat } from 'hooks/common/';
import { useGetProfile } from 'hooks/api/login';
import { Toast } from 'components/Toast';
import styles from './Layout.module.css';

const Layout = (): JSX.Element => {
  useOfflineNetworkToast();
  const { data: profile } = useGetProfile();
  const { registerChat } = useIntercomChat();

  useEffect(() => {
    if (profile) {
      registerChat?.();
    }
  }, [profile]);

  return (
    <>
      <div className={styles.layout}>
        <SidebarMenu />
        <div className={styles.layoutWrapper}>
          <div className={styles.layoutContent}>{<Outlet />}</div>
        </div>
      </div>
      <Toast />
    </>
  );
};

export default Layout;
